import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const PROFILE_REQUEST = 'sherrinford/profile/list/PROFILE_REQUEST'
export const PROFILE_SUCCESS = 'sherrinford/profile/list/PROFILE_SUCCESS'
export const PROFILE_ERROR = 'sherrinford/profile/list/PROFILE_ERROR'

export const IS_LOADING = 'sherrinford/profile/list/IS_LOADING'
export const DATA = 'sherrinford/profile/list/DATA'
export const SET_FILTER_VALUE = 'sherrinford/profile/list/SET_FILTER_VALUE'
export const SET_SORT_VALUE = 'sherrinford/profile/list/SET_SORT_VALUE'
export const CLEAR_FILTER_SORT = 'sherrinford/profile/list/CLEAR_FILTER_SORT'

export const SET_ROW_CLICKABLE = 'sherrinford/profile/list/SET_ROW_CLICKABLE'

const initialState = {
  data: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  isLoading: false,
  isError: false,
  filter: {
    profile: '',
    createStartDate: null,
    createEndDate: null,
    lastUpdateStartDate: null,
    lastUpdateEndDate: null,
    isCreateEndDateActive: false,
    isLastUpdateEndDateActive: false,
    country: '',
    defaultFeature: '',
    subscriptionPlan: '',
  },
  sort: {
    active: '',
    createdAt: 'ASC',
    updatedAt: 'ASC',
  },
  errorMessage: '',
  isRowClickable: false,
}

export default createReducer(initialState, {
  [PROFILE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PROFILE_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [PROFILE_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),

  [SET_FILTER_VALUE]: (state, data) => ({
    ...state,
    filter: {
      ...state.filter,
      ...data,
    },
  }),

  [SET_SORT_VALUE]: (state, data) => ({
    ...state,
    sort: {
      ...state.sort,
      ...data,
    },
  }),

  [SET_ROW_CLICKABLE]: (state, data) => ({
    ...state,
    isRowClickable: data,
  }),

  [CLEAR_FILTER_SORT]: state => ({
    ...state,
    sort: {
      active: '',
      createdAt: 'ASC',
      updatedAt: 'ASC',
    },
    filter: {
      profile: '',
      createStartDate: null,
      createEndDate: null,
      lastUpdateStartDate: null,
      lastUpdateEndDate: null,
      isCreateEndDateActive: false,
      isLastUpdateEndDateActive: false,
      country: '',
      defaultFeature: '',
      subscriptionPlan: '',
    },
  }),
})

export const getProfiles = qs => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [PROFILE_REQUEST, PROFILE_SUCCESS, PROFILE_ERROR],
    shuttle: {
      method: 'GET',
      path: '/profile',
      authorization: `${token}`,
      payloads: qs,
    },
  }
}

export const setFilterValue = data => ({
  type: [SET_FILTER_VALUE],
  payload: data,
})

export const setSortValue = data => ({
  type: [SET_SORT_VALUE],
  payload: data,
})

export const clearFilterSort = () => ({
  type: [CLEAR_FILTER_SORT],
})

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const setRowClickable = data => ({
  type: [SET_ROW_CLICKABLE],
  payload: data,
})
